import './App.less';

import { ConfigProvider, Layout, App as AntdApp } from 'antd';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Route, Routes } from 'react-router-dom';

import { ScrollToTop } from '@/components/atoms';
import { ForgotPassword, Locked, Login, ResetPassword, SignUp, SosSurvey, VerifyEmail, VerifyMobile } from '@/components/pages';
import { Frame } from '@/components/templates';
import { withAnalytics } from '@/routes';
import React from 'react';
import '@ant-design/v5-patch-for-react-19';

const App = () => (
    <ConfigProvider
        theme={{
            token: {
                colorPrimary: '#2588c9',
                borderRadius: 2,
                colorError: '#fe547b',
                colorText: '#000000',
                colorTextSecondary: '#000000',
                colorTextTertiary: '#000000',
                colorTextPlaceholder: '#000000',
                colorTextDisabled: '#000000',
                colorBgContainer: '#ffffff',
                colorBgLayout: '#ffffff',
            },
            components: {
                Layout: {
                    headerHeight: 76,
                    headerPadding: '0 0',
                    footerPadding: 0,
                    footerBg: 'white',
                },
                Menu: {
                    darkItemBg: '#4a4a49',
                    darkItemColor: '#ffffff',
                    darkItemSelectedBg: '#1d1d1b',
                    darkItemHoverBg: '#1d1d1b',
                    fontSize: 20,
                },
                Modal: {
                    colorBgMask: 'fade(@black, 75%)',
                },
                Input: {
                    colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
                },
                Card: {},
                Statistic: {
                    colorTextDescription: 'rgba(0, 0, 0, 0.45)',
                    colorTextHeading: 'rgba(0, 0, 0, .85)',
                },
            },
        }}
    >
        <AntdApp>
            <HelmetProvider>
                <Layout>
                    <Helmet defaultTitle="Skiggle - a community sharing in times of need" titleTemplate="Skiggle - %s" />
                    <Routes>
                        {/* Auth routes need to come first */}
                        <Route element={React.createElement(withAnalytics(Login))} path="/login" />
                        <Route element={React.createElement(withAnalytics(ForgotPassword))} path="/forgot-password" />
                        <Route element={React.createElement(withAnalytics(Locked))} path="/locked" />
                        <Route element={React.createElement(withAnalytics(ResetPassword))} path="/reset-password/:token" />
                        <Route element={React.createElement(withAnalytics(SignUp))} path="/sign-up" />
                        <Route element={React.createElement(withAnalytics(SosSurvey))} path="/sos/survey/:token/:feedback" />
                        <Route element={React.createElement(withAnalytics(VerifyEmail))} path="/verify-email/:token" />
                        <Route element={React.createElement(withAnalytics(VerifyMobile))} path="/verify-mobile" />

                        {/* Frame component with nested routes */}
                        <Route element={<Frame />} path="/*" />

                        {/* Remove the catch-all route since Frame already has its own catch-all */}
                    </Routes>
                    <ScrollToTop />
                </Layout>
            </HelmetProvider>
        </AntdApp>
    </ConfigProvider>
);

export { App };
